<template>
  <div class="query-container">
    <div class="card">
      <h1 class="title">{{$t('query.queryCard.h1')}}</h1>
      <p class="desc">{{$t('query.queryCard.p')}}</p>
      <a-textarea v-model="value" :placeholder="placeholder" :rows="8" style="resize: none" />
      <div class="button-container">
        <a-button class="query-button" type="primary" @click="goResult">{{$t('query.queryCard.submit')}}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: '',
    };
  },
  computed:{
    placeholder(){
      return this.$t('query.queryCard.placeholder')
    }
  },
  methods: {
    goResult() {
      if(!this.value) return this.$message.warning('请输入要查询的单号')
      this.$router.push({name:'queryResult',params:{codes:this.value}})
    },
  },
};
</script>

<style lang="less" scoped>
.query-container {
  padding: 28px 0;
  background-color: #f1f3fa;
  .card {
    box-sizing: border-box;
    width: 50%;
    margin: 0 auto;
    padding: 24px;
    border-radius: 12px;
    background-color: #fff;
    .title{
        // font-weight: bold;
        color: #ff5d1b;
    }
    .button-container {
      margin-top: 24px;
      .query-button {
        margin-right: 0;
      }
    }
  }
}
</style>